import './authViewport.css'

export function installAuthViewport(router) {
  const root = document.documentElement
  const viewport = window.visualViewport
  let active = false
  let frame = 0

  function update() {
    frame = 0
    if (!active) return
    const height = viewport ? viewport.height : window.innerHeight
    const top = viewport ? viewport.offsetTop : 0
    root.style.setProperty('--auth-viewport-height', `${Math.round(height)}px`)
    root.style.setProperty('--auth-viewport-top', `${Math.max(0, Math.round(top))}px`)
  }

  function scheduleUpdate() {
    if (!frame) frame = window.requestAnimationFrame(update)
  }

  router.afterEach(to => {
    const enabled = ['/login', '/register'].includes(to.path.toLowerCase())
    if (enabled === active) {
      if (active) update()
      return
    }
    active = enabled
    root.classList.toggle('auth-screen-active', active)
    if (active) {
      window.scrollTo(0, 0)
      update()
      window.addEventListener('resize', scheduleUpdate)
      if (viewport) {
        viewport.addEventListener('resize', scheduleUpdate)
        viewport.addEventListener('scroll', scheduleUpdate)
      }
    } else {
      window.removeEventListener('resize', scheduleUpdate)
      if (viewport) {
        viewport.removeEventListener('resize', scheduleUpdate)
        viewport.removeEventListener('scroll', scheduleUpdate)
      }
      if (frame) window.cancelAnimationFrame(frame)
      frame = 0
      root.style.removeProperty('--auth-viewport-height')
      root.style.removeProperty('--auth-viewport-top')
    }
  })
}
